import { ReactElement } from "react";

export const CardMeta = ({ item }: { item: Travelguide.POI }): ReactElement => (
  <p>{item.category.name}</p>
);
